// Registers the global axios error handler for the
// factored_receivables_frozen 423 response. The interceptor in
// middleware/authorizationProvider.js looks up this code in the
// errorCodeHandlers registry; this file is imported once at module
// boot via factoringClient/index.js so the registration happens before
// any API call can fire.

import { get } from "lodash";

import { registerErrorCodeHandler } from "../../middleware/errorCodeHandlers";
import { openSnackbar } from "../ui";
import getFreezeBlockedMessage from "../../helpers/freezeBlockedToast";

registerErrorCodeHandler("factored_receivables_frozen", (error, store) => {
  const operation = get(error, "response.data.operation");
  const message = getFreezeBlockedMessage(operation);
  store.dispatch(openSnackbar("error", message));
  // Rewrite the response body so the interceptor's downstream
  // formatError(error) pass returns the friendly message as the first
  // element of its array. Without this, callers that do
  // openSnackbar("error", head(err)) dispatch a second toast carrying
  // the raw "factored_receivables_frozen" code field — which overwrites
  // our snackbar.
  if (error.response && error.response.data) {
    error.response.data = { detail: message };
  }
});
